import React from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
import MapV2 from './MapV2';
var MapWrapper = function MapWrapper(props) {
  return /*#__PURE__*/React.createElement(Wrapper, {
    apiKey: props.mapsApiKey
  }, /*#__PURE__*/React.createElement(MapV2, Object.assign({}, props)));
};
export default MapWrapper;